// Shim for requestIdleCallback/cancelIdleCallback
// Extracted from https://github.com/behnammodi/polyfill/blob/e27dd5a590ff8c2b9f4b34cf307e76efdc239e14/window.polyfill.js
export function requestIdleCallback(callback, options = {}) {
    if (globalThis.requestIdleCallback) {
        return globalThis.requestIdleCallback(callback, options);
    }
    const relaxation = 1;
    const timeout = options.timeout || relaxation;
    const start = performance.now();
    return setTimeout(function() {
        callback({
            get didTimeout () {
                return options.timeout ? false : performance.now() - start - relaxation > timeout;
            },
            timeRemaining () {
                return Math.max(0, relaxation + (performance.now() - start));
            }
        });
    }, relaxation);
}
export function cancelIdleCallback(id) {
    if (globalThis.cancelIdleCallback) {
        return globalThis.cancelIdleCallback(id);
    }
    return clearTimeout(id);
}

//# sourceMappingURL=idleCallback.js.map